import React from 'react'
import TaskForm from './TaskForm'
import {Modal} from 'react-bootstrap'


const TaskNew = ({show,handleModalClose,handleSubmit}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Neue Seite</Modal.Title>
        </Modal.Header>
          <TaskForm
             handleSubmit={handleSubmit}
            />
        </Modal>
  </div>
)

export default TaskNew